<template>
    <section id="" class="px-2 mb-8 font-ww-medium lg:px-4 md:mb-0 lg:mt-8">
        
       <div class="grid">
        <div class="flex flex-wrap order-2 overflow-hidden gap-y-1 md:gap-y-4 md:order-1">
            <div class="w-full px-3">
            <div class="hidden max-w-screen-md mx-auto mt-6 text-center md:mb-4 h3 md:block xl:max-w-lg" v-html="sectionTitle">
            </div>
            <div class="max-w-screen-md mx-auto mt-6 mb-3 leading-7 text-center md:mb-4 h2 md:hidden" v-html="sectionTitleMobile">
            </div>

        </div>
            <!-- Image Blocks -->
            <div v-for="(image, index) in images"
                :class="index < 6 ? 'p-1.5 w-1/3 md:w-1/6 overflow-hidden' : 'p-1.5 w-full md:w-1/4 overflow-hidden'"
                :key="index" class="">
                <nuxt-img class="hidden w-full md:block" width="325" height="494" loading="lazy" format="webp"
                    :alt="image.alt" :src="image.src" sizes="xs:100px sm:160px md:200px lg:231px xl:220px 2xl:325px" />
                <nuxt-img v-if="image.mobileImageSrc" class="w-full md:hidden" width="325" height="494" loading="lazy"
                    format="webp" :alt="image.alt" :src="image.mobileImageSrc"
                    sizes="xs:100px sm:160px md:200px lg:231px xl:220px 2xl:325px" />
                <div class="hidden mt-0.5 text-15 leading-3 text-center md:block" v-html="image.imageName"></div>
            </div>
        </div>

        <nuxt-img class="px-4 mt-4 mb-4 md:mt-8 lg:w-full lg:mt-12 md:order-2 md:mb-0" width="1000" height="600"
            sizes="sm:400px md:768px lg:1024px xl:1024px" loading="lazy" format="webp" :alt="imageAlt"
            :src="imageSrc"></nuxt-img>
       </div>
    </section>
</template>

<script setup>

const props = defineProps({
    sectionTitle: {
        type: String,
        default: 'Everyone Is Talking About Lifeboost Coffee Including:'
    },
    sectionTitleMobile: {
        type: String,
        default: 'Influencers & Celebrities Love this Coffee...'
    },
    images: {
        type: Array,
        default: () => [
            { src: '/assets/images/imageLine1.jpg', alt: 'image1', mobileImageSrc: '/assets/images/imageLine1.jpg', imageName: 'Adina Porter' },
            { src: '/assets/images/imageLine2.jpg', alt: 'image2', mobileImageSrc: '/assets/images/imageLine2.jpg', imageName: 'Jordan Sparks' },
            { src: '/assets/images/imageLine3.jpg', alt: 'image3', mobileImageSrc: '/assets/images/imageLine3.jpg', imageName: 'Terrence Terrell' },
            { src: '/assets/images/imageLine4.jpg', alt: 'image3', mobileImageSrc: '/assets/images/imageLine4.jpg', imageName: 'Viola Davis' },
            { src: '/assets/images/imageLine5.jpg', alt: 'image5', mobileImageSrc: '/assets/images/imageLine5.jpg', imageName: 'Wilmer Valderrama' },
            { src: '/assets/images/imageLine6.jpg', alt: 'image6', mobileImageSrc: '/assets/images/imageLine6.jpg', imageName: 'Jaime Alexander' },
            { src: '/assets/images/desktop-shop.png', alt: 'image7', mobileImageSrc: '/assets/images/imageLine7.jpg', imageName: 'coffeeorbust.com' },
            { src: '/assets/images/desktop-shop-2.png', alt: 'image8', mobileImageSrc: '/assets/images/imageLine8.jpg', imageName: 'coffeehow.com' },
            { src: '/assets/images/desktop-shop-3.png', alt: 'image9', mobileImageSrc: '/assets/images/imageLine9.jpg', imageName: 'coffeeaffection.com' },
            { src: '/assets/images/desktop-shop-4.png', alt: 'image10', mobileImageSrc: '', imageName: 'thecoffeefolk.com' },
        ]
    },
    imageAlt: {
        type: String,
        default: "social media results"
    },
    imageSrc: {
        type: String,
        default: "/assets/images/fb-results.jpg"
    }
});

defineBuilderComponent({
    friendlyName: "Influencers",
    inputs: [
        {
            name: "sectionTitle",
            type: "richText",
            defaultValue: "Everyone Is Talking About Lifeboost Coffee Including:"
        },
        {
            name: "sectionTitleMobile",
            type: "richText",
            defaultValue: "Influencers & Celebrities Love this Coffee..."
        },
        {
            name: "images",
            type: "list",
            defaultValue: [
                {
                    src: "/assets/images/imageLine1.jpg",
                    alt: "image1",
                    mobileImageSrc: "/assets/images/imageLine1.jpg",
                    imageName: "Adina Porter"
                },
                {
                    src: "/assets/images/imageLine2.jpg",
                    alt: "image2",
                    mobileImageSrc: "/assets/images/imageLine2.jpg",
                    imageName: "Jordan Sparks"
                },
                {
                    src: "/assets/images/imageLine3.jpg",
                    alt: "image3",
                    mobileImageSrc: "/assets/images/imageLine3.jpg",
                    imageName: "Terrence Terrell"
                },
                {
                    src: "/assets/images/imageLine4.jpg",
                    alt: "image4",
                    mobileImageSrc: "/assets/images/imageLine4.jpg",
                    imageName: "Viola Davis"
                },
                {
                    src: "/assets/images/imageLine5.jpg",
                    alt: "image5",
                    mobileImageSrc: "/assets/images/imageLine5.jpg",
                    imageName: "Wilmer Valderrama"
                },
                {
                    src: "/assets/images/imageLine6.jpg",
                    alt: "image6",
                    mobileImageSrc: "/assets/images/imageLine6.jpg",
                    imageName: "Jaime Alexander"
                },
                {
                    src: "/assets/images/desktop-shop.png",
                    alt: "image7",
                    mobileImageSrc: "/assets/images/imageLine7.jpg",
                    imageName: "coffeeorbust.com"
                },
                {
                    src: "/assets/images/desktop-shop-2.png",
                    alt: "image8",
                    mobileImageSrc: "/assets/images/imageLine8.jpg",
                    imageName: "coffeehow.com"
                },
                {
                    src: "/assets/images/desktop-shop-3.png",
                    alt: "image9",
                    mobileImageSrc: "/assets/images/imageLine9.jpg",
                    imageName: "coffeeaffection.com"
                },
                {
                    src: "/assets/images/desktop-shop-4.png",
                    alt: "image10",
                    mobileImageSrc: "",
                    imageName: "thecoffeefolk.com"
                }
            ],
            subFields: [
                {
                    name: "src",
                    type: "file",
                    allowedFileTypes: [
                        "jpeg",
                        "jpg",
                        "png",
                        "webp"
                    ],
                    required: true
                },
                {
                    name: "alt",
                    type: "string"
                },
                {
                    name: "mobileImageSrc",
                    type: "file",
                    allowedFileTypes: [
                        "jpeg",
                        "jpg",
                        "png",
                        "webp"
                    ]
                },
                {
                    name: "imageName",
                    type: "string"
                }
            ]
        },
        {
            name: "imageAlt",
            type: "text",
            defaultValue: "social media results"
        },
        {
            name: "imageSrc",
            type: "file",
            allowedFileTypes: ["jpeg", "jpg", "png", "svg", "webp"],
            defaultValue: "/assets/images/fb-results.jpg"
        }
    ]
});
</script>